// ログイン画面: マジックリンク + Google
import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function LoginPage() {
  const { signInWithMagicLink, signInWithGoogle } = useAuth();
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleMagicLink = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSending(true);
    setError(null);
    const { error: err } = await signInWithMagicLink(email.trim());
    setSending(false);
    if (err) {
      setError(err);
    } else {
      setSent(true);
    }
  };

  const handleGoogle = async () => {
    setError(null);
    const { error: err } = await signInWithGoogle();
    if (err) setError(err);
  };

  return (
    <>
      <section className="hero">
        <h1>ログイン</h1>
        <p className="sub">家族みんなで使うため、まずはログインしてください</p>
      </section>

      <div className="card">
        <h2>📧 メールでログイン</h2>
        <p className="description">パスワード不要。メールに届くリンクをクリックするだけ。</p>
        {sent ? (
          <div className="status-banner">
            ✅ {email} 宛にログインリンクを送りました。メールを確認してください。
          </div>
        ) : (
          <form onSubmit={handleMagicLink}>
            <div className="form-row">
              <label>メールアドレス</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
            </div>
            <button className="btn btn-primary" type="submit" disabled={sending}>
              {sending ? '送信中...' : 'ログインリンクを送る'}
            </button>
          </form>
        )}
      </div>

      <div className="card">
        <h2>または</h2>
        <button className="btn btn-secondary" onClick={handleGoogle} style={{ width: '100%' }}>
          🔵 Googleでログイン
        </button>
      </div>

      {error && <div className="alert">エラー: {error}</div>}
    </>
  );
}
